<template>
  <div class="roomList__address-form">
    <!-- <p class="title is-4">Add Address Book</p> -->
    <form @submit.prevent="validateBeforeSubmit">
      <div class="columns">
        <div class="column is-one-fifth">
          <b-field
            :type="{'is-danger': errors.has('device')}"
            :message="errors.first('device')"
            custom-class="has-text-weight-normal"
          >
            <template slot="label">
              Tên của thiết bị đầu cuối <span class="has-text-danger">*</span>
            </template>
            <b-input
              v-model="device"
              name="device"
              v-validate="{required: true}"
              size="is-medium"
              data-vv-as="Tên của thiết bị đầu cuối"
            ></b-input>
          </b-field>
        </div>
        <div class="column is-one-fifth">
          <b-field
            placeholder="Select"
            :type="{'is-danger': errors.has('dial-type')}"
            :message="[{
            'Loại kết nối là bắt buộc': errors.firstByRule('dial-type', 'required')
            }]"
            custom-class="has-text-weight-normal"
          >
            <template slot="label">
              Loại kết nối <span class="has-text-danger">*</span>
            </template>
            <b-select
              name="dial-type"
              size="is-medium"
              v-model="dialType"
              v-validate="{required: true}"
              class="dial-type"
            >
              <option value disabled hidden>--------</option>
              <option
                v-for="option in diaTypelList"
                :value="option.txt"
                :key="option.key"
              >{{ option.txt }}</option>
            </b-select>
          </b-field>
        </div>
        <div class="column is-one-fifth">
          <b-field
            :type="{'is-danger': errors.has('dial-info')}"
            :message="[{
              'Thông tin cuộc gọi là bắt buộc': errors.firstByRule('dial-info', 'required')
            }]"
            custom-class="has-text-weight-normal"
          >
            <template slot="label">
              Thông tin cuộc gọi <span class="has-text-danger">*</span>
            </template>
            <b-input
              v-model="dialInfo"
              name="dial-info"
              v-validate="{required: true}"
              size="is-medium"
            ></b-input>
          </b-field>
        </div>
        <!--<div class="column is-one-fifth">
          <b-field label="IP" :type="{'is-danger': errors.has('ip')}" :message="errors.first('ip')">
            <b-input
              v-model="ip"
              placeholder="IP"
              name="ip"
              v-validate="{required: true}"
              size="is-medium"
            ></b-input>
          </b-field>
        </div>-->

        <div class="column is-one-fifth">
          <b-field label></b-field>
          <button type="submit" class="button is-info button-add-address">Thêm danh bạ</button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      diaTypelList: [{ id: 2, txt: "sip" }],
      device: "",
      dialType: "",
      dialInfo: "",
      ip: "0.0.0.0"
    };
  },
  methods: {
    ...mapActions("room", ["createAddressBook"]),
    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          const newAddressBook = {
            device: this.device,
            dialType: this.dialType,
            dialInfo: this.dialInfo,
            ip: this.ip
          };
          this.createAddressBook(newAddressBook).then(result => {
            if (result.data.status) {
              this.$toast.open({
                message: "Tạo mới danh bạ thành công!!",
                type: "is-info"
              });
              this.resetData();
              this.$nextTick(() => {
                this.$validator.reset();
              });
            } else {
              this.$toast.open({
                message: "Nhập thông tin lỗi",
                type: "is-danger"
              });
            }
          });
        }
      });
    },
    resetData() {
      this.device = "";
      this.dialType = "";
      this.dialInfo = "";
      this.ip = "";
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/form.scss";
.roomList {
  &__address-form {
    margin-top: 10px;
    margin-bottom: 30px;
  }
}
.button-add-address {
  margin-top: 16px;
}
</style>